import { ConsortiumRepoImpl } from "domain/repository/ChargeDetailMaintenance/ConsortiumRepoImpl";
import { ChargeTypeRepoImpl } from "domain/repository/ChargeType/ChargeTypeRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { FspDirectionRefRepoImpl } from "domain/repository/FspDirectionRef/FspDirectionRefRepoImpl";
import { MasterDataRepoImpl } from "domain/repository/MasterData/MasterDataRepoImpl";
import { MasterFSPRepoImpl } from "domain/repository/MasterFSP/MasterFSPRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { useMasterFSPMaintenanceTracked } from "presentation/store/MasterFSP/MasterFSPMaintenanceProvider";
import { MasterFSPMaintenanceVM } from "presentation/viewModel/MasterFSP/MasterFSPMaintenanceVM";
import { useMemo } from "react";

export const useMasterFSPMaintenanceVM = () => {
    const [, setMasterFSPMaintenanceState] = useMasterFSPMaintenanceTracked();
    const masterFSPMainVM = useMemo(() =>
        MasterFSPMaintenanceVM({
            dispatch: [setMasterFSPMaintenanceState],
            repo: MasterFSPRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            consortiumRepo: ConsortiumRepoImpl(),
            masterDataRepo: MasterDataRepoImpl(),
            chargeTypeRepo: ChargeTypeRepoImpl(),
            fspDirectionRefRepo: FspDirectionRefRepoImpl(),
        }), [setMasterFSPMaintenanceState])

    return masterFSPMainVM
}

